import { TranslationFunction } from '@/contexts/i18n-context';

interface InsuranceCoverageDisplayConfig {
  isSuccess: boolean;
  title: string;
  description: string;
  banner?: {
    label: string;
    description: string;
  };
}

const coverageTranslationBase = 'visit.insuranceInformation.coverage';

interface GetInsuranceCoverageDisplayConfigParams {
  t: TranslationFunction;
  insuranceActive: boolean;
  isGovernmentProgram: boolean;
  requiresPcpSpecialistReferral: boolean;
  hasVisitWithinSevenDays: boolean;
  displayOncePerWeekInsuranceDisclaimer: boolean;
}

export function getInsuranceCoverageDisplayConfig({
  t,
  insuranceActive,
  isGovernmentProgram,
  requiresPcpSpecialistReferral,
  hasVisitWithinSevenDays,
  displayOncePerWeekInsuranceDisclaimer,
}: GetInsuranceCoverageDisplayConfigParams): InsuranceCoverageDisplayConfig {
  const isSuccess = insuranceActive && !isGovernmentProgram && !requiresPcpSpecialistReferral;

  const descriptionVariant = isSuccess
    ? 'success'
    : isGovernmentProgram
      ? 'governmentProgram'
      : requiresPcpSpecialistReferral
        ? 'pcpReferralRequired'
        : 'fail';

  const config: InsuranceCoverageDisplayConfig = {
    isSuccess,
    title: t(`${coverageTranslationBase}.description.${descriptionVariant}.title`),
    description: t(`${coverageTranslationBase}.description.${descriptionVariant}.text`),
  };

  if (displayOncePerWeekInsuranceDisclaimer && isSuccess) {
    config.banner = hasVisitWithinSevenDays
      ? {
          label: t(`${coverageTranslationBase}.subsequentVisitBanner.notice`),
          description: t(`${coverageTranslationBase}.subsequentVisitBanner.disclaimer`),
        }
      : {
          label: t(`${coverageTranslationBase}.subsequentVisitBanner.label`),
          description: t(`${coverageTranslationBase}.subsequentVisitBanner.description`),
        };
  }

  return config;
}
